import SSRProvider from './SSRProvider';
export default SSRProvider;